export default __webpack_public_path__ + "static/media/fundo-procuracao.2ec415e1.png";